import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { error } from 'console';

@Component({
  selector: 'app-detailed-error',
  templateUrl: './detailed-error.component.html',
  styleUrls: ['./detailed-error.component.css']
})
export class DetailedErrorComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DetailedErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { errors: { row: number, column: number, message: string }[] }
  ) {
    console.log(data);
    
  }
  ngOnInit(): void {
  }

}
